import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AccountService } from '../../../services/account.service';

@Component({
  selector: 'app-email-verify-dialog',
  templateUrl: './email-verify-dialog.component.html',
  styleUrls: ['./email-verify-dialog.component.css']
})
export class EmailVerifyDialogComponent implements OnInit {
  api_success: string;
  api_error: any;
  providerId: any;
  btndisabled = false;

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    if (this.data.type === 'provider') {
      this.providerId = this.data.account.providerId;
    } else if (this.data.type === 'customer') {
      this.providerId = this.data.account;
    } else {
        this.providerId = this.data;
    }
  }

onConfirm() {
   this.api_success = '';
   this.api_error = '';
   this.btndisabled =  true;
     this.accountService.emailUnverify(this.providerId)
  .subscribe( data => {
    this.api_success = 'E-mail unverified successfully';
    setTimeout(() => {
      this.dialogRef.close('reloadlist');
      }, 2000);
    },
 (error) => {
  this.btndisabled = false;
  this.api_error = error.error;
  });

}
}
